var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPursueStudy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.864,
    height: 24.615,
    viewBox: "0 0 26.864 24.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1068",
    "data-name": "Groupe 1068",
    transform: "translate(-591.043 -707.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10412",
    "data-name": "Trac\\xE9 10412",
    d: "M613.7,730.243l4.543-4.543v5.654l-1.713,1.713a1.737,1.737,0,0,1-.573.386l-3.081,1.263a.614.614,0,0,1-.24.053.639.639,0,0,1-.585-.877l1.269-3.075A1.722,1.722,0,0,1,613.7,730.243Z",
    transform: "translate(-8.705 -7.758)",
    fill: "#77a395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10413",
    "data-name": "Trac\\xE9 10413",
    d: "M609.536,708.189v8.1l-5.367,5.367a2.867,2.867,0,0,0-.637.959l-1.269,3.075a1.809,1.809,0,0,0,1.666,2.491,1.725,1.725,0,0,0,.684-.14l3.081-1.263a3,3,0,0,0,.953-.637l.889-.889v5.215a1.169,1.169,0,0,1-1.169,1.169H592.212a1.169,1.169,0,0,1-1.169-1.169V708.189a1.169,1.169,0,0,1,1.169-1.169h16.155A1.169,1.169,0,0,1,609.536,708.189Z",
    fill: "#77a395"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1063",
    "data-name": "Groupe 1063",
    transform: "translate(603.297 712.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10414",
    "data-name": "Trac\\xE9 10414",
    d: "M626.339,719.325l-8.1,8.092-1.713,1.713a1.738,1.738,0,0,1-.573.386l-3.081,1.263a.613.613,0,0,1-.24.053.639.639,0,0,1-.585-.877l1.269-3.075a1.721,1.721,0,0,1,.38-.573l9.811-9.811a.894.894,0,0,1,.62-.275.564.564,0,0,1,.415.164l1.906,1.9A.756.756,0,0,1,626.339,719.325Z",
    transform: "translate(-612.002 -716.22)",
    fill: "#77a395"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPursueStudy);
export default __webpack_public_path__ + "static/media/pursue_study.d4b58dc5364f6ad14514587a4ff00c5c.svg";
export { ForwardRef as ReactComponent };